<template>
    <dynamic-chart :charts="charts"></dynamic-chart>
</template>

<script>
    import DynamicChart from "../components/dynamic-chart/DynamicChart";
    import user from "@/api/user.js";

    export default {
        data() {
            return {
                charts: []
            }
        },
        mounted() {
            this.getChartData();
        },
        created() {
          // call firstload of master data
          this.getListPriority();
          this.getListVisitType();
          this.getListInsurer();
          this.getListPhysicians();
          this.getListWard();
          this.getListAvailableTestPCR();
          this.getListAvailableTestClinic();
        },
        methods: {
            async getChartData() {
              const frm = await user.myDashboard();
              if (frm.data.status) {
                this.charts = frm.data.data;
                this.$vs.loading.close();
              }
            },
            async getListPriority() {
              await this.$store
                .dispatch("master/getListPriority")
                .then(() => {})
                .catch();
            },
            async getListVisitType() {
              await this.$store
                .dispatch("master/getListVisitType")
                .then(() => {})
                .catch();
            },
            async getListInsurer() {
              await this.$store
                .dispatch("master/getListInsurer")
                .then(() => {})
                .catch();
            },
            async getListPhysicians() {
              await this.$store
                .dispatch("master/getListPhysicians")
                .then(() => {})
                .catch();
            },
            async getListWard() {
              await this.$store
                .dispatch("master/getListWard")
                .then(() => {})
                .catch();
            },
            async getListAvailableTestPCR() {
              await this.$store
                .dispatch("master/getListAvailableTestPCR")
                .then(() => {})
                .catch();
            },
            async getListAvailableTestClinic() {
              await this.$store
                .dispatch("master/getListAvailableTestClinic")
                .then(() => {})
                .catch();
            }
        },
        components: {
            DynamicChart,
        }
    }

</script>
